<fcom-notification
  *ngIf="showNotification"
  [isClosable]="true"
  [layout]="NotificationLayout.EDGE_TO_EDGE"
  [theme]="NotificationTheme.SUCCESS"
  (closeClick)="showNotification = false"
>
  {{ 'newsletterSubscribedNotification' | finLocalization }}
</fcom-notification>
